import {
  Box,
  CardContent,
  Container,
  CssBaseline,
  FormControl,
  FormLabel,
  Grid,
  Link,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Typography,
  Card,
  TextField,
  PasswordStrengthMeter
} from 'src/shared/components/index';
import Group from './../../assets/images/user-logo.svg';
import BackgroundImage from 'src/assets/images/pageBg.png';
import Logo from './../../assets/images/bookind-d-lite.png';
import { useTranslation } from 'react-i18next';
import { resetPassowrdApiCall } from './apis/login';
import { setAccessToken } from 'src/shared/utils/storage';

const SetPassword = () => {
  const query = new URLSearchParams(window.location.search);
  setAccessToken(query.get('token'));
  //const
  const [password, setPassword] = useState<string>('');
  const [confirm_password, setConfirmPassword] = useState<string>('');
  const [errorMessagePassword, setErrorMessagePassword] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState<boolean>(true);
  const theme = useTheme();
  const navigate = useNavigate();

  const { t } = useTranslation('authentication');

  //methods
  const inputPasswordChange = (e: any, isError: boolean) => {
    setPassword(e?.target?.value);
    setIsPasswordError(isError);
    setErrorMessagePassword('');
  };

  const goToSignIn = () => {
    navigate('/');
  };

  const onSubmit = async () => {
    if (password.trim().length === 0) {
      setErrorMessagePassword('Password is required.');
    } else if (confirm_password.trim().length === 0) {
      setErrorMessage('Confirm Password is required.');
    } else if (password.trim() !== confirm_password.trim()) {
      setErrorMessage('Password and confirm password do not match');
    } else {
      const requestData = {
        newPassword: password,
        confirmPassword: confirm_password,
        loginType: query.get('loginType')
      };
      try {
        const response = await resetPassowrdApiCall(requestData);
        if (response) {
          setIsResetPassword(false);
        }
      } catch (error) {
        setErrorMessage(error.response.data.message[0]);
      }
    }
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
        onSubmit();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [password, confirm_password, onSubmit]);

  return (
    <div style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <Container className="loginWrapper h-100 flex-basic-center">
        <Container className="containerCenter" maxWidth="md">
          <Card
            className="card-size"
            sx={{
              bgcolor: theme.colors.alpha.white
            }}
          >
            <Grid container spacing={2}>
              <Grid
                className="flex-basic-center grid-size"
                item
                xs={12}
                md={6}
                sm={6}
                lg={6}
              >
                <Box>
                  <img src={Group} alt="Person" className="image-size" />
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                style={{ display: isResetPassword ? 'line-through' : 'none' }}
              >
                <CardContent sx={{ p: 5 }}>
                  <CssBaseline />

                  <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography
                      variant="h2"
                      color={theme.colors.primary.main}
                      sx={{ mb: 1 }}
                      align="left"
                      title="welcome_heading"
                    >
                      {t('set-password')}
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Box>
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        error={errorMessagePassword != ''}
                        onChange={(event) => {
                          inputPasswordChange(event, false);
                        }}
                      />

                      {errorMessagePassword && (
                        <Box className="setpassword-error">
                          <Typography
                            variant="h4"
                            color="text"
                            fontWeight="normal"
                          >
                            <FormControl error={true} variant="standard">
                              <FormLabel id="demo-error-radios">
                                {errorMessagePassword}
                              </FormLabel>
                            </FormControl>
                          </Typography>
                        </Box>
                      )}

                      <PasswordStrengthMeter
                        password={password}
                        isError={isPasswordError}
                      />
                    </Box>
                    <Box>
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="confirm_password"
                        label="Confirm Password"
                        type="password"
                        id="confirm_password"
                        autoComplete="current-password"
                        value={confirm_password}
                        error={errorMessage != ''}
                        onChange={(e) => {
                          setErrorMessage('');
                          setConfirmPassword(e?.target?.value);
                        }}
                      />
                      {errorMessage && (
                        <Box className="error-message">
                          <Typography
                            variant="h4"
                            color="text"
                            fontWeight="normal"
                          >
                            <FormControl error={true} variant="standard">
                              <FormLabel id="demo-error-radios">
                                {errorMessage}
                              </FormLabel>
                            </FormControl>
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                      btnText="Set Password"
                      onClick={onSubmit}
                    />
                    <Link
                      onClick={goToSignIn}
                      variant="body2"
                      style={{ cursor: 'pointer' }}
                    >
                      {t('existing-account')}
                    </Link>
                  </Box>
                </CardContent>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <CardContent sx={{ p: 5 }}>
                  <Box
                    className="flex-basic-center"
                    sx={{ mb: 3, className: 'justify-basic-start' }}
                  >
                    <img src={Logo} alt="bookingDliteLogo.png logo" />
                  </Box>
                  <CssBaseline />

                  <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography
                      variant="h2"
                      color={theme.colors.primary.main}
                      sx={{ mb: 1 }}
                      align="left"
                      title="heading"
                    >
                      {t('set-password')}
                    </Typography>

                    <Typography
                      variant="h5"
                      color={theme.colors.primary}
                      sx={{ mt: 8 }}
                      align="left"
                      title="subHeading"
                    >
                      {t('reset-password')}
                    </Typography>
                  </Box>

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    onClick={() => goToSignIn()}
                    btnText={t('back-to-login')}
                    sx={{ bgcolor: theme.colors.primary, mt: 12 }}
                  ></Button>
                </CardContent>
              </Grid>
            </Grid>
          </Card>
        </Container>
      </Container>
    </div>
  );
};

export default SetPassword;
